import ControlledField from '../../ControlledField';
import FormDateSelect from '../../FormDateSelect';
import FormNote from '../../FormNote';
import { FormCustomQuestionProps } from '../types';

const DateQuestion = ({ name, label, helpText, isRequired }: FormCustomQuestionProps) => (
  <ControlledField name={name}>
    <div>
      <ControlledField.Label isRequired={isRequired}>{label}</ControlledField.Label>
      {helpText && <FormNote>{helpText}</FormNote>}
    </div>
    <ControlledField.Control as={FormDateSelect} />
    <ControlledField.ErrorMessage />
  </ControlledField>
);

export default DateQuestion;
